import { Theme } from '@emotion/react';
import { SxProps } from '@mui/system';

const styles = {
  container: {
    backgroundColor: 'common.lightBackgroundColor',

  },
  subContainer: {
    paddingX: '20px',
    paddingY: '24px',
  },
  buttonContainer: {
    gap: '15px',
    flex: 1,
    position: 'sticky',
    bottom: 0,
    width: '100%',
    paddingY: '16px',
    backgroundColor: 'common.lightBackgroundColor',
    justifyContent: 'flex-end',
    boxShadow: '0px -2px 4px 0px #0000000A',
  },
  secondaryButton: {
    backgroundColor: 'secondary.main',
    color: 'primary.main',
    '&:hover': {
      backgroundColor: 'common.secondaryButtonHover',
      color: 'primary.main',
    },
  },
  closeButton: {
    mr: '40px',
    width: 202,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
